export function applyExchangeRate(originalValue: number, rate: number): number {
  return originalValue * rate;
}
